import React from "react";
import {
  Bathtub as BathtubIcon,
  CleaningServices as CleaningIcon,
  Water as WaterIcon,
  HealthAndSafety as HealthIcon,
} from "@mui/icons-material";
import CategoryPageTemplate from "../CategoryPageTemplate";
import { sanitaryWareCategories } from "./sanitaryWareData";

const SanitaryWarePage: React.FC = () => {
  const features = [
    { icon: BathtubIcon, text: "Complete Bathroom Solutions" },
    { icon: CleaningIcon, text: "Hygienic Design" },
    { icon: WaterIcon, text: "Water Saving Technology" },
    { icon: HealthIcon, text: "Health & Safety Compliant" },
  ];

  return (
    <CategoryPageTemplate
      title="Sanitary Ware Collection"
      subtitle="Complete Bathroom Sanitary Solutions"
      description="Explore our comprehensive range of sanitary ware including toilets, wash basins, and bathroom suites. Each product features modern design, water-saving technology, and hygienic materials for complete bathroom solutions."
      categoryData={sanitaryWareCategories}
      categoryType="Sanitary Ware"
      gradientCategory="Sanitary Ware"
      icon={BathtubIcon}
      features={features}
    />
  );
};

export default SanitaryWarePage;
